import { render, staticRenderFns } from "./LoadDiagram.vue?vue&type=template&id=60c0e4af&scoped=true"
import script from "./LoadDiagram.vue?vue&type=script&lang=js"
export * from "./LoadDiagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0e4af",
  null
  
)

export default component.exports